import { useEffect, useState } from "react"

const HOVER_QUERY = "(hover: hover) and (pointer: fine)"

/**
 * True on devices with a real pointer that can hover (desktop mouse/trackpad),
 * false on touch devices. Uses the hover/pointer media query rather than
 * user-agent sniffing so hybrid devices are classified by their active input.
 */
export const useHoverCapable = () => {
  const [hoverCapable, setHoverCapable] = useState(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return true
    return window.matchMedia(HOVER_QUERY).matches
  })

  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return undefined
    const mediaQuery = window.matchMedia(HOVER_QUERY)
    const handleChange = (event) => setHoverCapable(event.matches)
    mediaQuery.addEventListener("change", handleChange)
    setHoverCapable(mediaQuery.matches)
    return () => mediaQuery.removeEventListener("change", handleChange)
  }, [])

  return hoverCapable
}

export default useHoverCapable
